<template>
  <div class="row">
    <div class="col-12">
      <h2>{{ $t('payment_methods.create') }}</h2>
    </div>

    <div class="col-12 mt-4">
      <form class="row" @submit.prevent="createPaymentMethod">
        <FormFields v-model:formData="formData"/>
        <div class="col-12 col-lg-3 mt-3">
          <button class="btn btn-success" type="submit" :disabled="saving">
            {{ $t('save') }}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import {usePaymentMethodStore} from "@/stores/payment_method";
import {Helpers} from "@/helpers";
import {ROUTES} from "@/scripts/constants";
import FormFields from "@/pages/payment_methods/components/FormFields.vue";

export default {
  name: 'PaymentMethodsCreate',
  components: {
    FormFields,
  },
  setup() {
    return {
      paymentMethodStore: usePaymentMethodStore(),
    }
  },
  data() {
    return {
      formData: {
        organization_id: '',
        name: '',
        key: '',
        group: '',
        position: 0,
        notes: '',
      },
      saving: false,
    }
  },
  created() {
    this.setTitle(this.$t('payment_methods.create'))
  },
  methods: {
    buildPayload() {
      return {
        organization_id: this.formData.organization_id === '' ? null : Number(this.formData.organization_id),
        name: this.formData.name,
        key: this.formData.key,
        group: this.formData.group,
        position: this.formData.position === '' ? null : Number(this.formData.position),
        notes: this.formData.notes,
      }
    },
    createPaymentMethod() {
      this.saving = true
      this.paymentMethodStore.create(this.buildPayload()).then(({data}) => {
        Helpers.emitter.emit('success', this.$t('payment_methods.created'))
        const id = data?.payment_method?.id
        if (id) {
          this.$router.push({name: ROUTES.PAYMENT_METHODS.SHOW, params: {id}})
          return
        }
        this.$router.push({name: ROUTES.PAYMENT_METHODS.INDEX})
      }).finally(() => {
        this.saving = false
      })
    }
  }
}
</script>
